import { clamp } from '../core/noise';

const FULL_CARVE_DISTANCE = 120;

export function steeringFromDrag(dragX: number): number {
  return clamp(dragX / FULL_CARVE_DISTANCE, -1, 1);
}

export class TouchSteering {
  value = 0;

  private pointerId: number | null = null;
  private startX = 0;
  private target = 0;

  constructor(private readonly element: HTMLElement) {
    element.addEventListener('pointerdown', this.onPointerDown, { passive: false });
    element.addEventListener('pointermove', this.onPointerMove, { passive: false });
    element.addEventListener('pointerup', this.onPointerUp, { passive: false });
    element.addEventListener('pointercancel', this.onPointerUp, { passive: false });
    element.addEventListener('contextmenu', this.preventDefault);
  }

  update(delta: number): void {
    const responsiveness = this.pointerId === null ? 7 : 13;
    this.value += (this.target - this.value) * (1 - Math.exp(-responsiveness * delta));
  }

  dispose(): void {
    this.element.removeEventListener('pointerdown', this.onPointerDown);
    this.element.removeEventListener('pointermove', this.onPointerMove);
    this.element.removeEventListener('pointerup', this.onPointerUp);
    this.element.removeEventListener('pointercancel', this.onPointerUp);
    this.element.removeEventListener('contextmenu', this.preventDefault);
  }

  private readonly onPointerDown = (event: PointerEvent): void => {
    if (this.pointerId !== null) return;
    event.preventDefault();
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.target = 0;
    this.element.setPointerCapture(event.pointerId);
  };

  private readonly onPointerMove = (event: PointerEvent): void => {
    if (event.pointerId !== this.pointerId) return;
    event.preventDefault();
    this.target = steeringFromDrag(event.clientX - this.startX);
  };

  private readonly onPointerUp = (event: PointerEvent): void => {
    if (event.pointerId !== this.pointerId) return;
    event.preventDefault();
    this.pointerId = null;
    this.target = 0;
  };

  private readonly preventDefault = (event: Event): void => event.preventDefault();
}
